import { useEffect, useState } from "react";
import PopupAHSF from "../../../Components/PopupAHSF";
import TableAHSF from "../../../Components/TableAHSF";

import BudgetAdministrativeCostsAddEdit from "./BudgetAdministrativeCostsAddEdit";
import { useSelector, useDispatch } from "react-redux";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import Swal from "sweetalert2";
import { DeleteAdministrativeCostsAndMonth } from "../../../Redux/Reducers/BudgetInformation/AdministrativeCosts";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const BudgetAdministrativeCosts = () => {
  const AppGuid = useParams()
  const [bI_DirectCostsGuid, setBI_DirectCostsGuid] = useState("");
  const [
    estimatedBudgetForAdministrativeCostsId,
    setEstimatedBudgetForAdministrativeCostsId,
  ] = useState("");
  const dispatch = useDispatch();
  const AddAdministrativeCosts = useSelector(
    (state) => state.administrativeCosts.AddAdministrativeCosts
  );
  const renderDeleteAdministrativeCostsAndMonth = useSelector(
    (state) => state.administrativeCosts.DeleteAdministrativeCostsAndMonth
  );
  const [PopupComponentViewStatus, setPopupComponentViewStatus] =
    useState(false);
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
//popup props for showing popup
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <BudgetAdministrativeCostsAddEdit
        monthDataApi={false}
        ViewData={false}
        Action={"add"}
      />
    ),
    maxWidth: "1200px",
    maxHeight: "600px",
    title: "التكاليف الإدارية",
  };
  const RequestAccessor = [
    {
      KeyName: "itemName",
      ShowStatus: true,
      NmaeColumn: "البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfUnits",
      ShowStatus: true,
      NmaeColumn: "عدد الوحدات	",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "unitPrice",
      ShowStatus: true,
      NmaeColumn: "سعر الوحدة	",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "frequency",
      ShowStatus: true,
      NmaeColumn: "التكرار",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "beneficiaryContribution",
      ShowStatus: true,
      NmaeColumn: "مساهمة المستفيد",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "shomanContribution",
      ShowStatus: true,
      NmaeColumn: "مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sldssdsaadsd");
        setEstimatedBudgetForAdministrativeCostsId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          //if user click confirmed delete row from table
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(
              DeleteAdministrativeCostsAndMonth({
                bI_AB_EstimatedBudgetForAdministrativeCostsId: e.target.value,
              })
            );
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },

    {
      Click: async (e) => {
        setEstimatedBudgetForAdministrativeCostsId(e.target.value);
        closePopupViewComponent();
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: shouldDisableFields,
    },
  ];
  const RequestsColumns = [];
  const closePopupViewComponent = () => {
    if (PopupComponentViewStatus) {
      setPopupComponentViewStatus(false);
    } else {
      setPopupComponentViewStatus(true);
    }
  };

  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
//to  refresh table 
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [AddAdministrativeCosts, renderDeleteAdministrativeCostsAndMonth]);

  return (state.ApplicationInformation && state.ActiveRound)||decryptToken(AppGuid.AppGuid) ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"bI_AB_EstimatedBudgetForAdministrativeCostsId"}
        valueButtonAction={"bI_AB_EstimatedBudgetForAdministrativeCostsId"}
        URL={`api/AdministrativeCosts/GetAdministrativeCostsListByAppGuid`}
        UrlBody={{
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          )||decryptToken(AppGuid.AppGuid) ,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"التكاليف الإدارية"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={true}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
            { keyName: "beneficiaryContribution", nameColimn: " مساهمة المستفيد " },
            { keyName: "shomanContribution", nameColimn: " مساهمة شومان " },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
      <PopupAHSF
        title={"التكاليف الإدارية"}
        componentBody={
          <BudgetAdministrativeCostsAddEdit
            monthDataApi={true}
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            estimatedBudgetForAdministrativeCostsId={
              estimatedBudgetForAdministrativeCostsId
            }
          />
        }
        maxWidth="1200px"
        maxHeight="600px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
      <PopupAHSF
        title={"التكاليف الإدارية"}
        componentBody={
          <BudgetAdministrativeCostsAddEdit
            monthDataApi={true}
            ViewData={true}
            disabledData={true}
            Action={"view"}
            estimatedBudgetForAdministrativeCostsId={
              estimatedBudgetForAdministrativeCostsId
            }
          />
        }
        maxWidth="1200px"
        maxHeight="600px"
        isPopupOpenStatus={PopupComponentViewStatus}
        isPopupOpenFunction={closePopupViewComponent}
      />
    </>
  ) : (
    ""
  );
};

export default BudgetAdministrativeCosts;
